import React from 'react'
import styled from 'styled-components'

export const Card = styled.div`
  background: ${props => props.theme.colors.brand.white};
  border: 1px solid ${props => props.theme.colors.greys.dividerGray};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
    border-radius: 12px;
    height: 80px;
    width: 100%;
    max-width: 350px;
    gap: 8px;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`
